import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { IconButton, Menu, MenuItem, Link } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { useTranslation } from 'react-i18next';
import { config } from '../../../../constants';
import { CONSTANTS } from '../../../../constants/constants';
import { connect } from 'react-redux';
import API_REST from '../../../../api-rest-uruk';

const MobileMenuItem = ({ document, setCancelFlowDialog, setDeleteFlowDialog, handleUpdateDocument, markAsReadDocument, appConfig }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { t } = useTranslation();
  const open = Boolean(anchorEl);
  const ITEM_HEIGHT = 48;

  const { markAsRead: appMarkAsRead } = appConfig;
  const { status, flowId, fileUrl } = document;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  let currentStep;

  let flow;
  if (document.flow) {
    flow = JSON.parse(document.flow);
    currentStep = flow.steps.find(step => step.status === CONSTANTS.FLOW.STATUS.SEND_TO_SIGN);
  }

  const downloadPdfCertificateEvidence = async () => {
    API_REST.getCertificate(flowId)
      .then(response => window.open(response, '_blank'))
      .catch(err => console.error('[ERROR]: ', err));
  };

  return (
    <>
      <IconButton aria-label='more' aria-controls='long-menu' aria-haspopup='true' onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        id='long-menu'
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: '30ch'
          }
        }}
      >
        {status === CONSTANTS.DOCUMENT.STATUS.INIT &&
          <Link component={RouterLink} to={`/document/flow/${document.id}`} style={{ textDecoration: 'none' }}>
            <MenuItem>
              {t('documentMenu:createFlow')}
            </MenuItem>
          </Link>
        }
        {document.fileUrl &&
        <Link component={RouterLink} to={`/document/detail/${document.id}`} style={{ textDecoration: 'none' }}>
          <MenuItem>
            {t('documentMenu:Ver documento')}
          </MenuItem>
        </Link>
        }
        {fileUrl && status === CONSTANTS.FLOW.STATUS.SIGNED && (flow.certifiedEvidence && flow.certifiedEvidence === 'true') &&
        <Link
          style={{ textDecoration: 'none' }}
          onClick={() => downloadPdfCertificateEvidence()}
        >
          <MenuItem>
            {t('documentMenu:PDFCertificate')}
          </MenuItem>
        </Link>

        }
        {(status === CONSTANTS.DOCUMENT.STATUS.SEND_TO_SIGN || status === CONSTANTS.DOCUMENT.STATUS.SIGNED) &&
          <Link
            component={RouterLink}
            to={{ pathname: `${config.FIRMA_FRONT_URL}/validate/${flowId}` }}
            target='_blank'
            style={{ textDecoration: 'none' }}
          >
            <MenuItem>
              {t('documentMenu:viewSignedDocument')}
            </MenuItem>
          </Link>
        }
        {(status === CONSTANTS.DOCUMENT.STATUS.REJECTED || status === CONSTANTS.DOCUMENT.STATUS.CANCELLED || status === CONSTANTS.DOCUMENT.STATUS.INIT || status === CONSTANTS.DOCUMENT.STATUS.ERROR) &&
          <MenuItem key='Eliminar' onClick={() => setDeleteFlowDialog(true)}>
            {t('documentMenu:delete')}
          </MenuItem>
        }
        {status === CONSTANTS.DOCUMENT.STATUS.SEND_TO_SIGN && currentStep && !currentStep.automatic &&
          <MenuItem
            key='Cancelar' onClick={() => {
              setCancelFlowDialog(true);
              handleClose();
            }}
          >
            {t('documentMenu:cancel')}
          </MenuItem>
        }
        {appMarkAsRead && status === CONSTANTS.DOCUMENT.STATUS.SIGNED &&
          <MenuItem
            key='markAsRead' onClick={() => handleUpdateDocument(!markAsReadDocument)}
          >
            {markAsReadDocument && t('documentMenu:markAsNotRead')}
            {!markAsReadDocument && t('documentMenu:markAsRead')}
          </MenuItem>
        }
      </Menu>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    appConfig: state.config
  };
};

MobileMenuItem.propTypes = {
  document: PropTypes.object.isRequired,
  setCancelFlowDialog: PropTypes.func.isRequired,
  setDeleteFlowDialog: PropTypes.func.isRequired,
  appConfig: PropTypes.object.isRequired
};

export default connect(mapStateToProps, null)(MobileMenuItem);
